function InitAnimation(){

    jQuery(function() {

        if(jQuery('.circular-gallery').length > 0){
           let distance = jQuery('.circular-gallery').offset().top;
            jQuery(window).scroll(function() {
                if ( distance  - jQuery(this).scrollTop()  <= 100)  {
                    jQuery('.circular-gallery').addClass("animate");
                } 
            });
        }
       
    });

}

export default InitAnimation;